document.addEventListener("DOMContentLoaded", () => {
  const orderFormRoot = document.querySelector(".order-form.container");
  const tableContainer = document.querySelector(".responsive-order-table");
  const paginationContainer = document.querySelector(".pagination-container");

  const searchInput = document.getElementById("product-search");
  const clearBtn = document.getElementById("clear-search");
  const feedback = document.getElementById("search-feedback");
  const filterFeedback = document.getElementById("filter-feedback");
  const activeFilterChips = document.getElementById("active-filter-chips");
  const cartCount = document.getElementById("cart-count");
  const searchContainer = document.querySelector(".search-container");
  const searchLoader = document.getElementById("search-loader");
  const cartNotification = document.getElementById("cart-notification");

  const resetFiltersBtn = document.getElementById("reset-filters");
  const sidebarFilters = Array.from(document.querySelectorAll(".sidebar-filter"));
  const filterGroups = Array.from(document.querySelectorAll(".filter-group"));

  const toggleFiltersBtn = document.getElementById("toggle-filters");
  const sidebar = document.getElementById("order-form-sidebar");

  if (!orderFormRoot || !tableContainer) return;

  const inventoryCache = new Map();
  let cartCountAbortController = null;

  function debounce(fn, delay = 250) {
    let timeoutId;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn(...args), delay);
    };
  }

  function normalizeValue(value) {
    return String(value || "").trim().toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function titleCaseLabel(value) {
    return String(value || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function isTabletOrMobile() {
    return window.innerWidth <= 991;
  }

  function closeSidebarIfNeeded() {
    if (!isTabletOrMobile() || !sidebar) return;
    sidebar.classList.remove("is-open");
    toggleFiltersBtn?.setAttribute("aria-expanded", "false");
  }

  function setSearchLoading(isLoading) {
    if (!searchContainer || !searchLoader) return;
    searchContainer.classList.toggle("loading", isLoading);
    searchLoader.classList.toggle("visible", isLoading);
  }

  function setFeedback(message) {
    if (feedback) feedback.textContent = message;
  }

  function setFilterFeedback(message) {
    if (filterFeedback) filterFeedback.textContent = message;
  }

  function setClearButtonVisible(isVisible) {
    if (!clearBtn) return;
    clearBtn.style.display = isVisible ? "flex" : "none";
  }

  function getProductGroups() {
    return Array.from(document.querySelectorAll("tbody.product-group"));
  }

  function getGroupData(group) {
    return {
      id: normalizeValue(group.dataset.productId),
      title: normalizeValue(group.dataset.productTitle),
      brand: normalizeValue(group.dataset.brand),
      externalCategory: normalizeValue(group.dataset.externalCategory),
      internalSubgroup: normalizeValue(group.dataset.internalSubgroup),
      visibilityScope: normalizeValue(group.dataset.visibilityScope),
      isTester: normalizeValue(group.dataset.isTester) === "true",
      skuValues: normalizeValue(group.dataset.skuValues).split(",").filter(Boolean),
    };
  }

  function getFilterLabel(type, value) {
    const normalizedType = normalizeValue(type);
    const normalizedValue = normalizeValue(value);

    const input = sidebarFilters.find(
      (item) =>
        normalizeValue(item.dataset.filterType) === normalizedType &&
        normalizeValue(item.value) === normalizedValue
    );

    if (input) {
      const label = input.closest("label")?.querySelector("span")?.textContent?.trim();
      if (label) return label;
    }

    if (normalizedType === "is-tester") return "Alleen testers";
    return titleCaseLabel(normalizedValue);
  }

  function getActiveFilters() {
    const filters = {
      brand: new Set(),
      externalCategory: new Set(),
      internalSubgroup: new Set(),
      isTester: false,
    };

    sidebarFilters.forEach((input) => {
      if (!input.checked) return;

      const type = input.dataset.filterType;
      const value = normalizeValue(input.value);

      if (type === "brand") {
        filters.brand.add(value);
      } else if (type === "external-category") {
        filters.externalCategory.add(value);
      } else if (type === "internal-subgroup") {
        filters.internalSubgroup.add(value);
      } else if (type === "is-tester" && value === "true") {
        filters.isTester = true;
      }
    });

    return filters;
  }

  function hasAnyActiveFilters(filters) {
    return (
      filters.brand.size > 0 ||
      filters.externalCategory.size > 0 ||
      filters.internalSubgroup.size > 0 ||
      filters.isTester
    );
  }

  function matchesSearch(group, rawSearch) {
    const query = normalizeValue(rawSearch);
    if (!query) return true;

    const data = getGroupData(group);

    if (data.title.includes(query)) return true;
    return data.skuValues.some((sku) => sku.includes(query));
  }

  function matchesFilters(group, filters) {
    const data = getGroupData(group);

    if (filters.brand.size > 0 && !filters.brand.has(data.brand)) {
      return false;
    }

    if (
      filters.externalCategory.size > 0 &&
      !filters.externalCategory.has(data.externalCategory)
    ) {
      return false;
    }

    if (
      filters.internalSubgroup.size > 0 &&
      !filters.internalSubgroup.has(data.internalSubgroup)
    ) {
      return false;
    }

    if (filters.isTester && !data.isTester) {
      return false;
    }

    return true;
  }

  function hideAllVariantRowsInsideGroup(group) {
    const variantRows = group.querySelectorAll(".variant-row");
    variantRows.forEach((row) => row.classList.add("hidden"));

    const toggleButton = group.querySelector(".btn-toggle-variants");
    if (toggleButton) {
      toggleButton.classList.remove("active");
      toggleButton.innerHTML = `
        <svg class="icon-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
        Toon varianten
      `;
    }
  }

  function updateVisibleState(group, visible) {
    group.style.display = visible ? "" : "none";
    if (!visible) {
      hideAllVariantRowsInsideGroup(group);
    }
  }

  function buildFilterSummary(filters) {
    const parts = [];

    if (filters.brand.size > 0) {
      parts.push(`${filters.brand.size} merkfilter(s)`);
    }

    if (filters.externalCategory.size > 0) {
      parts.push(`${filters.externalCategory.size} categoriefilter(s)`);
    }

    if (filters.internalSubgroup.size > 0) {
      parts.push(`${filters.internalSubgroup.size} subgroepfilter(s)`);
    }

    if (filters.isTester) {
      parts.push("alleen testers");
    }

    return parts.join(" · ");
  }

  function renderActiveFilterChips(rawSearch, filters) {
    if (!activeFilterChips) return;

    const chips = [];

    if (rawSearch) {
      chips.push(`
        <span class="active-filter-chip" data-chip-type="search">
          <span>Zoekterm: "${escapeHtml(rawSearch)}"</span>
          <button type="button" aria-label="Verwijder zoekterm" data-remove-chip="search">×</button>
        </span>
      `);
    }

    filters.brand.forEach((value) => {
      chips.push(`
        <span class="active-filter-chip" data-chip-type="brand" data-chip-value="${escapeHtml(value)}">
          <span>${escapeHtml(getFilterLabel("brand", value))}</span>
          <button type="button" aria-label="Verwijder filter ${escapeHtml(
            getFilterLabel("brand", value)
          )}" data-remove-chip="brand" data-remove-value="${escapeHtml(value)}">×</button>
        </span>
      `);
    });

    filters.externalCategory.forEach((value) => {
      chips.push(`
        <span class="active-filter-chip" data-chip-type="external-category" data-chip-value="${escapeHtml(
          value
        )}">
          <span>${escapeHtml(getFilterLabel("external-category", value))}</span>
          <button type="button" aria-label="Verwijder filter ${escapeHtml(
            getFilterLabel("external-category", value)
          )}" data-remove-chip="external-category" data-remove-value="${escapeHtml(value)}">×</button>
        </span>
      `);
    });

    filters.internalSubgroup.forEach((value) => {
      chips.push(`
        <span class="active-filter-chip" data-chip-type="internal-subgroup" data-chip-value="${escapeHtml(
          value
        )}">
          <span>${escapeHtml(getFilterLabel("internal-subgroup", value))}</span>
          <button type="button" aria-label="Verwijder filter ${escapeHtml(
            getFilterLabel("internal-subgroup", value)
          )}" data-remove-chip="internal-subgroup" data-remove-value="${escapeHtml(value)}">×</button>
        </span>
      `);
    });

    if (filters.isTester) {
      chips.push(`
        <span class="active-filter-chip" data-chip-type="is-tester" data-chip-value="true">
          <span>Alleen testers</span>
          <button type="button" aria-label="Verwijder filter Alleen testers" data-remove-chip="is-tester" data-remove-value="true">×</button>
        </span>
      `);
    }

    activeFilterChips.innerHTML = chips.join("");
  }

  function updateResultMessaging(visibleCount, rawSearch, filters) {
    const hasSearch = rawSearch.length > 0;
    const hasFilters = hasAnyActiveFilters(filters);
    const summary = buildFilterSummary(filters);

    if (hasSearch) {
      setFeedback(`Zoekterm actief: "${rawSearch}"`);
      setClearButtonVisible(true);
    } else {
      setFeedback("");
      setClearButtonVisible(hasFilters);
    }

    if (visibleCount === 0) {
      if (hasSearch || hasFilters) {
        const messageParts = [];
        if (hasSearch) messageParts.push("zoekopdracht");
        if (hasFilters) messageParts.push("actieve filters");
        setFilterFeedback(`Geen resultaten voor huidige ${messageParts.join(" en ")}.`);
      } else {
        setFilterFeedback("Geen resultaten.");
      }
      return;
    }

    if (hasSearch && hasFilters) {
      setFilterFeedback(
        summary
          ? `${visibleCount} product(en) zichtbaar · ${summary}`
          : `${visibleCount} product(en) zichtbaar`
      );
      return;
    }

    if (hasFilters) {
      setFilterFeedback(
        summary
          ? `${visibleCount} product(en) zichtbaar · ${summary}`
          : `${visibleCount} product(en) zichtbaar`
      );
      return;
    }

    if (hasSearch) {
      setFilterFeedback(`${visibleCount} product(en) gevonden`);
      return;
    }

    setFilterFeedback(`${visibleCount} product(en) zichtbaar`);
  }

  function applyClientSideFilters() {
    const rawSearch = (searchInput?.value || "").trim();
    const filters = getActiveFilters();
    const groups = getProductGroups();

    setSearchLoading(true);

    let visibleCount = 0;

    groups.forEach((group) => {
      const visible = matchesSearch(group, rawSearch) && matchesFilters(group, filters);
      updateVisibleState(group, visible);
      if (visible) visibleCount += 1;
    });

    renderActiveFilterChips(rawSearch, filters);
    updateResultMessaging(visibleCount, rawSearch, filters);

    if (paginationContainer) {
      paginationContainer.style.display =
        rawSearch.length > 0 || hasAnyActiveFilters(filters) ? "none" : "";
    }

    setSearchLoading(false);
  }

  function resetAllFilters({ closeSidebar = true } = {}) {
    sidebarFilters.forEach((input) => {
      input.checked = false;
    });

    if (searchInput) {
      searchInput.value = "";
    }

    setFeedback("");
    setFilterFeedback("");
    setClearButtonVisible(false);

    if (activeFilterChips) {
      activeFilterChips.innerHTML = "";
    }

    const groups = getProductGroups();
    groups.forEach((group) => {
      updateVisibleState(group, true);
    });

    if (paginationContainer && !paginationContainer.classList.contains("is-hidden")) {
      paginationContainer.style.display = "";
    }

    if (closeSidebar) {
      closeSidebarIfNeeded();
    }
  }

  function removeSingleFilterChip(type, value) {
    if (type === "search") {
      if (searchInput) searchInput.value = "";
      applyClientSideFilters();
      searchInput?.focus();
      return;
    }

    const normalizedType = normalizeValue(type);
    const normalizedValue = normalizeValue(value);

    sidebarFilters.forEach((input) => {
      const inputType = normalizeValue(input.dataset.filterType);
      const inputValue = normalizeValue(input.value);

      if (inputType === normalizedType && inputValue === normalizedValue) {
        input.checked = false;
      }
    });

    applyClientSideFilters();
  }

  async function updateCartCount() {
    if (!cartCount) return;

    try {
      if (cartCountAbortController) {
        cartCountAbortController.abort();
      }

      cartCountAbortController = new AbortController();

      const response = await fetch("/cart.js", {
        signal: cartCountAbortController.signal,
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const data = await response.json();
      const count = Number(data.item_count || 0);

      cartCount.textContent = String(count);
      cartCount.classList.toggle("visible", count > 0);
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("Fout bij ophalen cart:", error);
    }
  }

  function showCartNotification(message) {
    if (!cartNotification) return;

    cartNotification.textContent = message;
    cartNotification.classList.remove("hidden");
    cartNotification.classList.add("show");

    window.clearTimeout(showCartNotification._timeout);

    showCartNotification._timeout = window.setTimeout(() => {
      cartNotification.classList.remove("show");
      window.setTimeout(() => {
        cartNotification.classList.add("hidden");
      }, 220);
    }, 2600);
  }

  async function addToCart(button) {
    const variantId = button?.dataset?.id;
    if (!variantId) return;

    const wrapper = button.closest(".order-form-inline");
    if (!wrapper) return;

    const input = wrapper.querySelector(".qty-input");
    const quantity = Math.max(1, parseInt(input?.value, 10) || 1);
    const originalText = button.textContent;

    button.classList.add("loading");
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json",
        },
        body: new URLSearchParams({
          id: variantId,
          quantity: String(quantity),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.description || data?.message || "Toevoegen aan winkelmand mislukt."
        );
      }

      await updateCartCount();

      if (input) input.value = "1";

      if (data?.product_title) {
        showCartNotification(`"${data.product_title}" toegevoegd aan winkelmand`);
      } else {
        showCartNotification("Product toegevoegd aan winkelmand");
      }
    } catch (error) {
      console.error("Fout bij toevoegen:", error);
      alert(error.message || "Er ging iets mis bij het toevoegen aan de winkelmand.");
    } finally {
      button.classList.remove("loading");
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function toggleVariants(button) {
    const groupId = button?.dataset?.target;
    if (!groupId) return;

    const group = document.getElementById(groupId);
    if (!group || group.style.display === "none") return;

    const variantRows = group.querySelectorAll(".variant-row");
    if (!variantRows.length) return;

    const shouldShow = variantRows[0].classList.contains("hidden");

    variantRows.forEach((row) => {
      row.classList.toggle("hidden", !shouldShow);
    });

    button.classList.toggle("active", shouldShow);

    const label = shouldShow ? "Verberg varianten" : "Toon varianten";
    button.innerHTML = `
      <svg class="icon-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
      ${label}
    `;

    if (shouldShow) {
      fetchInventoryStatus(group);
    }
  }

  function updateQuantity(button, direction) {
    const form = button.closest(".order-form-inline");
    if (!form) return;

    const input = form.querySelector(".qty-input");
    if (!input || input.disabled) return;

    const current = Math.max(1, parseInt(input.value, 10) || 1);
    const nextValue = direction === "plus" ? current + 1 : Math.max(1, current - 1);

    input.value = String(nextValue);
  }

  function setInventoryCellState(cell, state, label) {
    cell.classList.remove(
      "status-in-stock",
      "status-limited",
      "status-out",
      "status-unknown"
    );

    cell.textContent = label;
    cell.classList.add(state);
  }

  function setFormAvailability(variantId, available, root = document) {
    const button = root.querySelector(`.btn-add-to-cart[data-id="${variantId}"]`);
    if (!button) return;

    const form = button.closest(".order-form-inline");
    const input = form?.querySelector(".qty-input");
    const minus = form?.querySelector(".minus");
    const plus = form?.querySelector(".plus");

    if (available) {
      button.disabled = false;
      button.textContent = "Toevoegen";
      button.classList.remove("btn-disabled");

      if (input) input.disabled = false;
      if (minus) minus.disabled = false;
      if (plus) plus.disabled = false;
    } else {
      button.disabled = true;
      button.textContent = "Uitverkocht";
      button.classList.add("btn-disabled");

      if (input) input.disabled = true;
      if (minus) minus.disabled = true;
      if (plus) plus.disabled = true;
    }
  }

  async function getInventoryStatus(variantId) {
    if (inventoryCache.has(variantId)) {
      return inventoryCache.get(variantId);
    }

    const promise = fetch(`/variants/${variantId}.js`, {
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Variant request failed: ${response.status}`);
        }

        const data = await response.json();

        return {
          available: Boolean(data.available),
          inventory_quantity:
            typeof data.inventory_quantity === "number" ? data.inventory_quantity : null,
        };
      })
      .catch((error) => {
        inventoryCache.delete(variantId);
        throw error;
      });

    inventoryCache.set(variantId, promise);
    return promise;
  }

  async function fetchInventoryStatus(root = document) {
    const cells = [...root.querySelectorAll(".inventory-status[data-variant-id]")];

    await Promise.allSettled(
      cells.map(async (cell) => {
        const variantId = cell.dataset.variantId;
        if (!variantId) return;

        try {
          const data = await getInventoryStatus(variantId);

          if (
            data.available &&
            typeof data.inventory_quantity === "number" &&
            data.inventory_quantity > 0 &&
            data.inventory_quantity <= 5
          ) {
            setInventoryCellState(cell, "status-limited", "Beperkte voorraad");
            setFormAvailability(variantId, true, root);
          } else if (data.available) {
            setInventoryCellState(cell, "status-in-stock", "Op voorraad");
            setFormAvailability(variantId, true, root);
          } else {
            setInventoryCellState(cell, "status-out", "Uitverkocht");
            setFormAvailability(variantId, false, root);
          }
        } catch (error) {
          console.error(`Voorraadfout voor variant ${variantId}:`, error);
          setInventoryCellState(cell, "status-unknown", "Onbekend");
        }
      })
    );
  }

  async function loadAllPaginatedProducts() {
    const autoLoadAllPages = orderFormRoot.dataset.autoLoadAllPages === "true";
    if (!autoLoadAllPages || !paginationContainer) return;

    const pageLinks = Array.from(paginationContainer.querySelectorAll(".pagination-link"))
      .map((link) => link.getAttribute("href"))
      .filter(Boolean);

    const uniquePageLinks = [...new Set(pageLinks)].filter((href) =>
      href.includes("page=")
    );

    if (!uniquePageLinks.length) {
      paginationContainer.classList.add("is-hidden");
      return;
    }

    setFilterFeedback("Extra producten laden...");

    const table = tableContainer.querySelector(".order-table");
    if (!table) return;

    const existingIds = new Set(
      getProductGroups().map((group) => normalizeValue(group.dataset.productId))
    );

    for (const href of uniquePageLinks) {
      try {
        const response = await fetch(href, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          throw new Error(`Pagina laden mislukt: ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const groups = Array.from(doc.querySelectorAll("tbody.product-group"));
        groups.forEach((group) => {
          const productId = normalizeValue(group.dataset.productId);
          if (productId && !existingIds.has(productId)) {
            existingIds.add(productId);
            table.appendChild(group);
          }
        });
      } catch (error) {
        console.error("Fout bij laden extra pagina:", error);
      }
    }

    paginationContainer.classList.add("is-hidden");
    setFilterFeedback("");
  }

  function initFilterGroups() {
    filterGroups.forEach((group) => {
      const toggle = group.querySelector(".filter-group-toggle");
      if (!toggle) return;

      toggle.addEventListener("click", () => {
        group.classList.toggle("is-collapsed");
      });
    });
  }

  function initResponsiveSidebarToggle() {
    if (!toggleFiltersBtn || !sidebar) return;

    toggleFiltersBtn.addEventListener("click", () => {
      const isOpen = sidebar.classList.toggle("is-open");
      toggleFiltersBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 991) {
        sidebar.classList.remove("is-open");
        toggleFiltersBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  const debouncedApplyFilters = debounce(() => {
    applyClientSideFilters();
  }, 200);

  if (searchInput) {
    searchInput.addEventListener("input", debouncedApplyFilters);

    searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        clearBtn?.click();
      }
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      if (searchInput) {
        searchInput.value = "";
      }
      applyClientSideFilters();
      searchInput?.focus();
    });
  }

  sidebarFilters.forEach((input) => {
    input.addEventListener("change", () => {
      applyClientSideFilters();
      closeSidebarIfNeeded();
    });
  });

  if (resetFiltersBtn) {
    resetFiltersBtn.addEventListener("click", () => {
      resetAllFilters({ closeSidebar: false });
      applyClientSideFilters();
    });
  }

  if (activeFilterChips) {
    activeFilterChips.addEventListener("click", (event) => {
      const button = event.target.closest("[data-remove-chip]");
      if (!button) return;

      const type = button.dataset.removeChip;
      const value = button.dataset.removeValue || "";
      removeSingleFilterChip(type, value);
    });
  }

  tableContainer.addEventListener("click", (event) => {
    const minusBtn = event.target.closest(".minus");
    if (minusBtn) {
      updateQuantity(minusBtn, "minus");
      return;
    }

    const plusBtn = event.target.closest(".plus");
    if (plusBtn) {
      updateQuantity(plusBtn, "plus");
      return;
    }

    const toggleBtn = event.target.closest(".btn-toggle-variants");
    if (toggleBtn) {
      toggleVariants(toggleBtn);
      return;
    }

    const addButton = event.target.closest(".btn-add-to-cart");
    if (addButton) {
      addToCart(addButton);
    }
  });

  tableContainer.addEventListener("input", (event) => {
    const input = event.target.closest(".qty-input");
    if (!input) return;

    const numericValue = parseInt(input.value, 10);
    if (!input.value || Number.isNaN(numericValue) || numericValue < 1) {
      input.value = "1";
    }
  });

  async function initOrderFormPage() {
    initFilterGroups();
    initResponsiveSidebarToggle();
    await loadAllPaginatedProducts();
    updateCartCount();
    await fetchInventoryStatus(tableContainer);
    applyClientSideFilters();
  }

  initOrderFormPage();
});